const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:6000';

export default API_URL;
